import { render, staticRenderFns } from "./TicketType.vue?vue&type=template&id=153951f1&scoped=true"
import script from "./TicketType.vue?vue&type=script&lang=js"
export * from "./TicketType.vue?vue&type=script&lang=js"
import style0 from "./TicketType.vue?vue&type=style&index=0&id=153951f1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153951f1",
  null
  
)

export default component.exports